module.exports = __webpack_public_path__ + "img/img-5.1ce9c2bd.png";